export interface ApiRequestOptions extends RequestInit {
  endpoint: string;
}

export async function apiFetch(options: ApiRequestOptions) {
  const { endpoint, ...fetchOptions } = options;
  const baseUrl = process.env.REACT_APP_API_URL;

  if (!baseUrl) {
    throw new Error("REACT_APP_API_URL environment variable is not set");
  }

  const normalizedEndpoint = endpoint.startsWith("/")
    ? endpoint
    : `/${endpoint}`;
  const url = `${baseUrl}${normalizedEndpoint}`;

  const response = await fetch(url, fetchOptions);

  const contentType = response.headers.get("content-type");
  let data;

  if (contentType && contentType.includes("application/json")) {
    data = await response.json();
  } else {
    data = await response.text();
  }

  if (!response.ok) {
    const errorMessage =
      typeof data === "object" && data.error
        ? data.error
        : `HTTP ${response.status}: ${response.statusText}`;
    throw new Error(errorMessage);
  }

  return data;
}
